export enum SMSTemplateType {
  CONFIRMATION = 'confirmation',
  REMINDER = 'reminder',
}

export const SMS_TEMPLATE_TYPES = Object.values(SMSTemplateType);
